function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'royalblue': 'rgb(9, 39, 89)','amalfiteal': 'rgb(65, 90, 113)','mastic': 'rgb(170, 160, 141)','sportgray': 'rgb(220, 219, 219)','desert': 'rgb(212, 181, 144)','havaianblue': 'rgb(63, 140, 202)','lavander': 'rgb(191, 175, 252)','pinkfizz': 'rgb(249, 141, 185)','kandypink': 'rgb(220, 166, 207)','skyblue': 'rgb(135, 172, 212)','pacificgray': 'rgb(199, 199, 199)','darkgray': 'rgb(82, 81, 86)','urbankakhi': 'rgb(79, 77, 52)','kellygreen': 'rgb(2, 122, 87)','stoneblue': 'rgb(87, 114, 133)','divablue': 'rgb(10, 115, 137)','swimmmingpool': 'rgb(4, 188, 217)','atoll': 'rgb(38, 149, 210)','milleniallilac': 'rgb(120, 121, 223)','natural': 'rgb(236, 231, 203)','warmtaupe': 'rgb(176, 141, 119)','surftheweb': 'rgb(19, 54, 136)','skyway': 'rgb(196, 204, 215)','skipper-blue': 'rgb(61, 63, 114)','jolly_green': 'rgb(3, 115, 79)','fuchsia_rose': 'rgb(182, 56, 103)','falcon': 'rgb(96, 82, 73)','drizzle': 'rgb(171, 166, 162)','cappuccino': 'rgb(93, 56, 47)','beetle': 'rgb(79, 83, 68)','alpine_green': 'rgb(15, 101, 102)','azure_blue': 'rgb(112, 163, 216)','black': 'rgb(0, 0, 0)','darkcherry': 'rgb(82, 19, 45)','grayfog': 'rgb(169, 191, 179)','acquagreen': 'rgb(169, 191, 179)','puresky': 'rgb(200, 213, 221)','khaki': 'rgb(84, 76, 65)','nordicblue': 'rgb(84, 110, 123)','softrose': 'rgb(230, 193, 177)','asphalt': 'rgb(60, 64, 67)','heathergray': 'rgb(145, 148, 155)','lime': 'rgb(203, 218, 117)','applegreen': 'rgb(61, 171, 84)','sage': 'rgb(157, 184, 171)','forestgreen': 'rgb(43, 60, 44)','bluefog': 'rgb(151, 171, 182)','navyblue': 'rgb(32, 38, 52)','burgundi': 'rgb(93, 43, 55)','radiantpurple': 'rgb(77, 64, 118)','magentapink': 'rgb(228, 39, 108)','mocha': 'rgb(104, 76, 65)','magentapink': 'rgb(253, 60, 121)','offwhite': 'rgb(249, 249, 249)','white': 'rgb(255, 255, 255)','yellow': 'rgb(255, 229, 0)','beige': 'rgb(234, 216, 171)','petroleum': 'rgb(32, 126, 113)','zinc': 'rgb(219, 219, 219)','seebreeze': 'rgb(47, 171, 228)','inkblue': 'rgb(29, 75, 134)','eucalyptus': 'rgb(92, 153, 117)','almondcream': 'rgb(212, 181, 144)','oceanblue': 'rgb(37, 147, 157)','turquose': 'rgb(15, 156, 250)','lightgray': 'rgb(173, 169, 169)','earthygreen': 'rgb(69, 120, 86)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
